// src/notices/index.js
// Notices — extracted from index.html (v105.x sprint, auto-generated header).
// Bundled by esbuild into dist/notices.js. The HTML loads it via
//   <script src="dist/notices.js"></script>
// and call sites use `Notices.<sub>.<fn>()` (e.g.
//   Notices.notify.showToast()
//   Notices.consent.showConsentModal()
//   Notices.feedback.renderFeedbackScreen()
// ).
//
// Backwards compat: index.html's trailing script block re-exposes the
// moved functions on window so existing call sites — both inline JS and
// onclick="" attributes — keep working without HTML edits.
//
// Free variables (DB, currentUser, currentStore, escapeHtml, WORKER_URL,
// fetch, console, document, window, ...) live in the inline globals
// scope of index.html. esbuild leaves them as bare references at runtime.

// ── notify ─────────────────────────────────────────────
export const notify = {};

function showToast(msg,type) {
  var t=document.getElementById('toast');
  t.textContent=msg; t.className='toast'+(type?' '+type:'');
  // v134.1: an error stays long enough to read (6s, not 2.8s), and a newer toast restarts the clock
  t.classList.add('show'); clearTimeout(showToast._t); showToast._t = setTimeout(function(){t.classList.remove('show');}, type==='error' ? 6000 : 2800);
}
notify.showToast = showToast;

function showUpdateBanner() {
  if (_versionBannerDismissed) return;
  var banner = document.getElementById('updateBanner');
  if (!banner) return;
  banner.style.display = 'flex';
  // Push body content down so the banner doesn't cover the topbar
  document.body.style.paddingTop = '46px';
}
notify.showUpdateBanner = showUpdateBanner;

function hideUpdateBanner() {
  var banner = document.getElementById('updateBanner');
  if (!banner) return;
  banner.style.display = 'none';
  document.body.style.paddingTop = '';
}
notify.hideUpdateBanner = hideUpdateBanner;

// ── consent ─────────────────────────────────────────────
export const consent = {};

function showConsentModal(staffId, onAcknowledged) {
  _consentStaffId = staffId;
  _consentOnAck = onAcknowledged || null;
  _consentLang = 'en';
  document.getElementById('consentCheckbox').checked = false;
  updateConsentBtn();
  renderConsentBody(false);
  // v135.0: an Arabic device opens the notice in Arabic (it has its own English/Arabic toggle, so the page translator leaves it alone)
  setConsentLang((typeof I18N !== 'undefined' && I18N.getLang && I18N.getLang() === 'ar') ? 'ar' : 'en');
  document.getElementById('consentModal').classList.add('open');
}
consent.showConsentModal = showConsentModal;

function setConsentLang(lang) {
  _consentLang = (lang === 'ar') ? 'ar' : 'en';
  var t = CONSENT_TEXT[_consentLang];
  var card = document.getElementById('consentCard');
  card.setAttribute('dir', t.dir);
  document.getElementById('consentTitle').textContent = t.title;
  document.getElementById('consentCheckLabel').textContent = t.checkLabel;
  document.getElementById('consentBtn').textContent = t.btn;
  document.getElementById('consentCancel').textContent = t.cancel;
  document.getElementById('consentLangEn').classList.toggle('active', _consentLang === 'en');
  document.getElementById('consentLangAr').classList.toggle('active', _consentLang === 'ar');
  // Re-render body in chosen language, preserving expand/collapse state
  var fullOpen = document.querySelector('.consent-full.open') !== null;
  renderConsentBody(fullOpen);
}
consent.setConsentLang = setConsentLang;

function renderConsentBody(showFull) {
  var t = CONSENT_TEXT[_consentLang];
  var html = '<p>' + t.short + '</p>';
  html += '<p><a class="consent-expand" id="consentExpandLink">'
    + (showFull ? t.collapseLink : t.expandLink) + '</a></p>';
  html += '<div class="consent-full' + (showFull ? ' open' : '') + '">';
  t.full.forEach(function(section){
    var heading = section[0], content = section[1];
    if (heading) html += '<h4>' + heading + '</h4>';
    if (Array.isArray(content)) {
      html += '<ul>';
      content.forEach(function(item){ html += '<li>' + item + '</li>'; });
      html += '</ul>';
    } else {
      html += '<p>' + content + '</p>';
    }
  });
  html += '</div>';
  var body = document.getElementById('consentBody');
  body.innerHTML = html;
  // Wire up the expand/collapse link
  document.getElementById('consentExpandLink').addEventListener('click', function(){
    renderConsentBody(!showFull);
  });
}
consent.renderConsentBody = renderConsentBody;

function updateConsentBtn() {
  var checked = document.getElementById('consentCheckbox').checked;
  document.getElementById('consentBtn').disabled = !checked;
}
consent.updateConsentBtn = updateConsentBtn;

async function acknowledgeConsent() {
  var sid = _consentStaffId;
  var lang = _consentLang;
  var cb = _consentOnAck;
  // Disable button to prevent double-tap
  var btn = document.getElementById('consentBtn');
  btn.disabled = true;
  btn.textContent = '…';
  try {
    await DB.staff.acknowledgeConsent(sid, CONSENT_VERSION, lang);
    // Update the local cache so we don't re-prompt this session
    var s = ALL_STAFF.find(function(x){return x.id===sid;});
    if (s) {
      s.consent_version = CONSENT_VERSION;
      s.consent_acknowledged_at = new Date().toISOString();
      s.consent_lang = lang;
    }
    document.getElementById('consentModal').classList.remove('open');
    _consentStaffId = null;
    _consentOnAck = null;
    if (typeof cb === 'function') cb();
  } catch(e) {
    console.warn('Consent save failed:', e);
    showToast('Could not save acknowledgement — check connection', 'error');
    var t = CONSENT_TEXT[_consentLang];
    btn.disabled = false;
    btn.textContent = t.btn;
  }
}
consent.acknowledgeConsent = acknowledgeConsent;

function cancelConsent() {
  document.getElementById('consentModal').classList.remove('open');
  _consentStaffId = null;
  _consentOnAck = null;  // queued action is dropped on cancel
}
consent.cancelConsent = cancelConsent;

// ── feedback ─────────────────────────────────────────────
export const feedback = {};

// v127.44 (Doha - Landmark Mall, 29 Jul): the screen carries TWO kinds now —
// 🐞 bug reports (unchanged: three fields + the AI clarify loop) and 💡 ideas
// (idea + how-it-helps; no "actually happened", no clarify — an idea is not a
// defect to interrogate). Same pipeline underneath: feedback_reports with
// kind='idea', screenshots ride along as before.
var _fbKind = 'bug';
var FB_COPY = {
  bug: {
    title: '\ud83d\udc1e Report a Problem',
    intro: 'Help us fix bugs faster. Tell us what you were doing, what you expected, and what actually happened.',
    doing: '1. What were you doing?', doingPh: 'e.g. Trying to clock in at 9am',
    expected: '2. What did you expect to happen?', expectedPh: 'e.g. The green button to turn to "Clocked in"',
  },
  idea: {
    title: '\ud83d\udca1 Share an Idea',
    intro: 'Suggestions, proposals, better ways of working \u2014 for the stores, the team or the company. Head Office reads every one.',
    doing: '1. Your idea', doingPh: 'e.g. A quick way to print the day\u2019s delivery list',
    expected: '2. How would it help?', expectedPh: 'e.g. Saves the morning shift ~15 minutes every delivery day',
  },
};
function fbSetKind(kind) {
  _fbKind = kind === 'idea' ? 'idea' : 'bug';
  var c = FB_COPY[_fbKind];
  var set = function (id, txt) { var el = document.getElementById(id); if (el) el.textContent = txt; };
  var setPh = function (id, txt) { var el = document.getElementById(id); if (el) el.placeholder = txt; };
  set('fbTitle', c.title); set('fbIntro', c.intro);
  set('fbDoingLabel', c.doing); setPh('fbDoing', c.doingPh);
  set('fbExpectedLabel', c.expected); setPh('fbExpected', c.expectedPh);
  var actual = document.getElementById('fbActualField');
  if (actual) actual.style.display = _fbKind === 'idea' ? 'none' : '';
  var styleBtn = function (id, on) {
    var el = document.getElementById(id); if (!el) return;
    el.style.background = on ? 'var(--green)' : 'var(--card)';
    el.style.color = on ? '#fff' : 'var(--text)';
    el.style.borderColor = on ? 'var(--green)' : 'var(--border-strong)';
  };
  styleBtn('fbKindBug', _fbKind === 'bug');
  styleBtn('fbKindIdea', _fbKind === 'idea');
}
feedback.fbSetKind = fbSetKind;

function renderFeedbackScreen(){
  fbSetKind(_fbKind);   // v127.44 — keep labels in sync with the picked kind
  // Clear form each visit
  var d = document.getElementById('fbDoing');
  var e = document.getElementById('fbExpected');
  var a = document.getElementById('fbActual');
  if (d) d.value = '';
  if (e) e.value = '';
  if (a) a.value = '';
  var st = document.getElementById('fbStatus'); if (st) st.innerHTML = '';
  var btn = document.getElementById('fbSubmitBtn'); if (btn) btn.disabled = false;
  var panel = document.getElementById('fbAiPanel'); if (panel) panel.innerHTML = '';
  fbResetShots();
  loadMyFeedbackReports();
}
feedback.renderFeedbackScreen = renderFeedbackScreen;

async function loadMyFeedbackReports(){
  var holder = document.getElementById('fbMyReports');
  if (!holder) return;
  holder.innerHTML = 'Loading…';
  var opts = {};
  if (currentUser) {
    if (currentUser.name) opts.userName = currentUser.name;
    if (currentUser.store) opts.store = currentUser.store;
  }
  try {
    var rows = await DB.feedback.mine(opts);
    if (!Array.isArray(rows) || rows.length === 0) {
      holder.innerHTML = '<div style="font-size:12px;color:var(--sub);font-style:italic">No reports submitted yet.</div>';
      return;
    }
    holder.innerHTML = rows.map(function(r){
      var dateStr = r.submitted_at ? new Date(r.submitted_at).toLocaleString('en-GB',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'}) : '';
      var status = r.status === 'done' ? '<span class="fb-badge fb-badge-done">✓ Done</span>' : '<span class="fb-badge fb-badge-new">New</span>';
      var summary = (r.doing || '').length > 80 ? (r.doing.slice(0,80) + '…') : (r.doing || '—');
      // Escape HTML
      summary = summary.replace(/</g,'&lt;').replace(/>/g,'&gt;');
      return '<div class="fb-report-item">'+
        '<div class="fb-rep-head">'+
          '<span class="fb-rep-date">'+dateStr+'</span>'+
          status+
        '</div>'+
        '<div class="fb-rep-body" translate="no">'+summary+'</div>'+   // v135.1: what the person wrote: never translated
      '</div>';
    }).join('');
  } catch (err) {
    holder.innerHTML = '<div style="font-size:12px;color:var(--red)">Failed to load: '+String(err && err.message ? err.message : 'unknown').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')+'</div>';   // v136.63 (war game, xss): escaped
  }
}
feedback.loadMyFeedbackReports = loadMyFeedbackReports;

// ── AI intake state (the clarify loop before a report is filed) ──
var _fbDraft = null;        // the report payload being clarified
var _fbHistory = [];        // [{q, a}, ...] of clarifying turns
var _fbLastQuestion = '';   // the question currently shown to the user

// ── Screenshots (v124.16) ──────────────────────────────────────────
// A staffer can attach up to 3 screenshots to a bug report. Each is compressed
// CLIENT-side (canvas resize → JPEG) to a bounded data URL, so we never try to
// upload a multi-MB phone photo over a shop's flaky wifi. The Worker re-checks
// the same size + count bounds server-side (the feedback POST is tokenless).
var _fbShots = [];          // [dataURL, ...] compressed, ready to submit
var FB_MAX_SHOTS = 3;
var FB_MAX_SHOT_LEN = 900000;   // must match the Worker's MAX_LEN

function fbResetShots(){
  _fbShots = [];
  var input = document.getElementById('fbShotInput'); if (input) input.value = '';
  _fbRenderThumbs();
}
feedback.fbResetShots = fbResetShots;

// v128.38 (Doha Landmark): documents ride the same pipeline as screenshots —
// a doc entry is a data:application/... URL; its tile shows a 📎 label
// instead of an <img> (a data: URL can't be usefully previewed inline).
function _fbDocLabel(src){
  if (/^data:application\/pdf/.test(src)) return 'PDF';
  if (/^data:application\/msword/.test(src)) return 'DOC';
  if (/^data:application\/vnd\.openxmlformats/.test(src)) return 'DOCX';
  return null;
}

function _fbRenderThumbs(){
  var wrap = document.getElementById('fbShotThumbs'); if (!wrap) return;
  wrap.innerHTML = _fbShots.map(function(src, i){
    var doc = _fbDocLabel(src);
    var inner = doc
      ? '<div style="width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;background:var(--surface-3);border-radius:8px;font-size:11px;font-weight:800;color:var(--text)">📎<span>' + doc + '</span></div>'
      : '<img src="' + src + '" alt="screenshot ' + (i + 1) + '">';
    return '<div class="fb-shot-thumb">' + inner +
      '<button type="button" aria-label="Remove attachment" onclick="fbRemoveScreenshot(' + i + ')">✕</button></div>';
  }).join('');
  var btn = document.getElementById('fbShotBtn');
  if (btn) btn.style.display = _fbShots.length >= FB_MAX_SHOTS ? 'none' : '';
}

// Downscale one image File to a bounded JPEG data URL. Longest edge ≤ 1400px,
// quality 0.7 — keeps a readable screenshot comfortably under the size cap.
function _fbCompress(file){
  return new Promise(function(resolve, reject){
    var reader = new FileReader();
    reader.onerror = function(){ reject(new Error('read failed')); };
    reader.onload = function(){
      var img = new Image();
      img.onerror = function(){ reject(new Error('decode failed')); };
      img.onload = function(){
        var max = 1400, w = img.width, h = img.height;
        if (w > max || h > max) {
          if (w >= h) { h = Math.round(h * max / w); w = max; }
          else { w = Math.round(w * max / h); h = max; }
        }
        var canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, w, h);
        try { resolve(canvas.toDataURL('image/jpeg', 0.7)); }
        catch (e) { reject(e); }
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}

// v125.100 — paste a screenshot straight into the bug-report form (Chaminda:
// "cut and paste directly from Snipping tool instead saved as JPEG and import
// from folder"). One document-level listener, active only while the form's
// thumbnail strip is on screen; pasted images go through the SAME compress +
// caps as the picker. Text pastes are untouched.
var _fbPasteBound = false;
function fbBindPaste(){
  if (_fbPasteBound || typeof document === 'undefined') return;
  _fbPasteBound = true;
  document.addEventListener('paste', async function (e) {
    try {
      if (!document.getElementById('fbShotThumbs')) return;   // form not on screen
      var items = (e.clipboardData && e.clipboardData.items) || [];
      var files = [];
      for (var i = 0; i < items.length; i++){
        if (items[i].kind === 'file' && /^image\//.test(items[i].type || '')) {
          var f = items[i].getAsFile();
          if (f) files.push(f);
        }
      }
      if (!files.length) return;
      e.preventDefault();
      var added = 0;
      for (var j = 0; j < files.length; j++){
        if (_fbShots.length >= FB_MAX_SHOTS) {
          if (typeof showToast === 'function') showToast('You can add up to ' + FB_MAX_SHOTS + ' screenshots', 'info');
          break;
        }
        try {
          var dataUrl = await _fbCompress(files[j]);
          if (dataUrl.length > FB_MAX_SHOT_LEN) {
            if (typeof showToast === 'function') showToast('That image is too large even after shrinking — try a tighter crop', 'error');
            continue;
          }
          _fbShots.push(dataUrl);
          added++;
        } catch (err2) {
          if (typeof showToast === 'function') showToast('Could not read that image — try adding it as a file', 'error');
        }
      }
      _fbRenderThumbs();
      if (added && typeof showToast === 'function') showToast('📷 Screenshot pasted');
    } catch (err) { /* a paste must never break the form */ }
  });
}
fbBindPaste();

// "Add screenshot" onchange handler. Compresses each picked image, enforces the
// count + size caps, and re-renders the thumbnail strip. Never throws to the
// caller — a bad image just gets skipped with a toast; the report still files.
// v128.38 (Doha Landmark): PDF/Word docs are accepted alongside images. A doc
// can't be canvas-compressed, so it is read RAW and must fit the SAME
// FB_MAX_SHOT_LEN cap the Worker enforces (~650KB of file) — bigger files get
// a clear toast pointing at the store email instead. The allow-list mirrors
// the Worker's filter exactly; anything else is skipped with a toast.
function _fbDocOk(f){
  var t = (f && f.type) || '';
  var n = ((f && f.name) || '').toLowerCase();
  if (t === 'application/pdf' || /\.pdf$/.test(n)) return 'application/pdf';
  if (t === 'application/msword' || /\.doc$/.test(n)) return 'application/msword';
  if (t === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || /\.docx$/.test(n)) {
    return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  }
  return null;
}

function _fbReadRaw(file, mime){
  return new Promise(function(resolve, reject){
    var reader = new FileReader();
    reader.onerror = function(){ reject(new Error('read failed')); };
    // Windows often reports an empty MIME for .doc/.docx — rebuild the data URL
    // with the mime the allow-list resolved so the Worker's filter matches.
    reader.onload = function(){
      var out = String(reader.result || '');
      resolve(out.replace(/^data:[^;]*;base64,/, 'data:' + mime + ';base64,'));
    };
    reader.readAsDataURL(file);
  });
}

async function fbAddScreenshots(input){
  var files = input && input.files ? Array.prototype.slice.call(input.files) : [];
  if (input) input.value = '';   // let the same file be re-picked later
  for (var i = 0; i < files.length; i++){
    if (_fbShots.length >= FB_MAX_SHOTS) {
      if (typeof showToast === 'function') showToast('You can add up to ' + FB_MAX_SHOTS + ' attachments', 'info');
      break;
    }
    var f = files[i];
    if (!f) continue;
    var docMime = _fbDocOk(f);
    if (!/^image\//.test(f.type || '') && !docMime) {
      if (typeof showToast === 'function') showToast('Only images, PDF or Word files can be attached', 'info');
      continue;
    }
    try {
      var dataUrl = docMime ? await _fbReadRaw(f, docMime) : await _fbCompress(f);
      if (dataUrl.length > FB_MAX_SHOT_LEN) {
        if (typeof showToast === 'function') showToast(docMime
          ? 'That file is too large (max ~650KB) — email it to the store inbox instead'
          : 'That image is too large even after shrinking — try a tighter crop', 'error');
        continue;
      }
      _fbShots.push(dataUrl);
    } catch (e) {
      if (typeof showToast === 'function') showToast('Could not attach that file', 'error');
    }
  }
  _fbRenderThumbs();
}
feedback.fbAddScreenshots = fbAddScreenshots;

function fbRemoveScreenshot(i){
  _fbShots.splice(i, 1);
  _fbRenderThumbs();
}
feedback.fbRemoveScreenshot = fbRemoveScreenshot;

async function submitFeedback(){
  var doing = (document.getElementById('fbDoing').value || '').trim();
  var expected = (document.getElementById('fbExpected').value || '').trim();
  var actual = (document.getElementById('fbActual').value || '').trim();
  var status = document.getElementById('fbStatus');
  var btn = document.getElementById('fbSubmitBtn');
  // v127.44: an idea has no "actually happened" — two fields only.
  if (_fbKind === 'idea' ? (!doing || !expected) : (!doing || !expected || !actual)) {
    status.innerHTML = '<span style="color:var(--red)">' + (_fbKind === 'idea' ? 'Please fill in your idea and how it would help.' : 'Please fill in all three fields.') + '</span>';
    return;
  }
  // Build the report once; the clarify loop may enrich `actual` before filing.
  _fbDraft = {
    kind: _fbKind,
    doing: doing,
    expected: expected,
    actual: _fbKind === 'idea' ? '(idea \u2014 no defect)' : actual,
    user_name: (currentUser && currentUser.name) || '(unknown)',
    user_role: (currentUser && currentUser.role) || '(unknown)',
    store: (currentUser && currentUser.store) || null,
    country: (currentUser && currentUser.country) || (typeof getStoreCountry === 'function' && currentUser && currentUser.store ? getStoreCountry(currentUser.store) : null),
    screen: currentScreen || 'unknown',
    app_version: APP_VERSION,
    user_agent: (navigator && navigator.userAgent) ? navigator.userAgent.slice(0, 300) : '',
    // Any attached screenshots ride along on the final submit (NOT on the clarify
    // call — that only sees the text fields). The Worker strips this off the
    // feedback_reports body and stores it in feedback_photos.
    screenshots: _fbShots.slice(),
  };
  _fbHistory = [];
  _fbLastQuestion = '';
  btn.disabled = true;
  // v127.44: ideas file straight away — the clarify loop interrogates defects,
  // and an idea is not a defect.
  if (_fbKind === 'idea') {
    status.innerHTML = '<span style="color:var(--sub)">Sending your idea\u2026</span>';
    _fbFinalSubmit(null);
    return;
  }
  status.innerHTML = '<span style="color:var(--sub)">Checking your report…</span>';
  _fbClarifyStep();
}

// One clarify round: ask the Worker whether the report is clear, or for one
// short question. The endpoint is gated + degrades to {status:'clear'}, and any
// network error here also falls through to filing as-is — the AI never blocks
// a staff member from reporting.
async function _fbClarifyStep(){
  var out = null;
  try {
    out = await DB.feedback.clarify({
      doing: _fbDraft.doing, expected: _fbDraft.expected, actual: _fbDraft.actual,
      store: _fbDraft.store, screen: _fbDraft.screen, country: _fbDraft.country, app_version: _fbDraft.app_version,
    }, _fbHistory);
  } catch (e) { out = { status: 'clear', summary: null }; }
  if (out && out.status === 'ask' && out.question) {
    _fbLastQuestion = out.question;
    _fbRenderQuestion(out.question);
  } else {
    _fbFinalSubmit(out && out.summary);
  }
}

// Show one plain-English question + an answer box, with a clear "Skip" escape.
function _fbRenderQuestion(question){
  var panel = document.getElementById('fbAiPanel');
  if (!panel) { _fbFinalSubmit(null); return; } // no panel in DOM → just file it
  document.getElementById('fbStatus').innerHTML = '';
  panel.innerHTML =
    '<div style="margin-top:12px;padding:12px;border:1px solid var(--green);border-radius:10px;background:rgba(34,197,94,.07)">' +
      '<div style="font-size:13px;font-weight:800;margin-bottom:6px">🤖 One quick question — it helps us fix it faster</div>' +
      '<div style="font-size:13px;line-height:1.45;margin-bottom:8px">' + escapeHtml(question) + '</div>' +
      '<textarea id="fbAnswer" rows="2" style="width:100%;box-sizing:border-box;border:1px solid var(--border-strong);border-radius:8px;padding:8px;font-family:inherit;font-size:13px" placeholder="Type your answer"></textarea>' +
      '<div style="display:flex;gap:8px;margin-top:8px">' +
        '<button type="button" class="fb-submit" style="flex:1;margin:0" onclick="fbAnswerClarify()">Send answer</button>' +
        '<button type="button" style="flex:0 0 auto;background:var(--border);color:var(--text);border:none;border-radius:8px;padding:0 14px;font-weight:600;cursor:pointer;font-family:inherit" onclick="fbSkipClarify()">Skip &amp; submit</button>' +
      '</div>' +
    '</div>';
  var ta = document.getElementById('fbAnswer'); if (ta) ta.focus();
}

// "Send answer" — record the Q&A and run another clarify round.
function fbAnswerClarify(){
  var ta = document.getElementById('fbAnswer');
  var answer = ((ta && ta.value) || '').trim();
  if (!answer) { if (ta) ta.focus(); return; }
  _fbHistory.push({ q: _fbLastQuestion, a: answer });
  var panel = document.getElementById('fbAiPanel'); if (panel) panel.innerHTML = '';
  document.getElementById('fbStatus').innerHTML = '<span style="color:var(--sub)">Thanks — checking…</span>';
  _fbClarifyStep();
}

// "Skip & submit" — file the report with whatever detail we have.
function fbSkipClarify(){ _fbFinalSubmit(null); }

// File the report. Folds any clarifying Q&A (+ AI summary) into `actual` so the
// developer sees the extra detail — no schema change. Always re-enables the form.
async function _fbFinalSubmit(summary){
  var status = document.getElementById('fbStatus');
  var btn = document.getElementById('fbSubmitBtn');
  var panel = document.getElementById('fbAiPanel'); if (panel) panel.innerHTML = '';
  status.innerHTML = '<span style="color:var(--sub)">Sending…</span>';
  var payload = {};
  for (var k in _fbDraft) { if (Object.prototype.hasOwnProperty.call(_fbDraft, k)) payload[k] = _fbDraft[k]; }
  if (_fbHistory.length || summary) {
    var extra = [];
    _fbHistory.forEach(function(qa){ extra.push('Q: ' + qa.q + '\nA: ' + qa.a); });
    if (summary) extra.push('AI summary: ' + summary);
    payload.actual = _fbDraft.actual + '\n\n— Clarified —\n' + extra.join('\n\n');
  }
  try {
    await DB.feedback.submit(payload);
    status.innerHTML = '<span style="color:var(--rota-green-ink)">✅ Thanks — report submitted.</span>';
    document.getElementById('fbDoing').value = '';
    document.getElementById('fbExpected').value = '';
    document.getElementById('fbActual').value = '';
    fbResetShots();
    btn.disabled = false;
    showToast('Report submitted — thanks!', 'success');
    loadMyFeedbackReports();
  } catch (err) {
    btn.disabled = false;
    status.innerHTML = '<span style="color:var(--red)">❌ '+(err && err.message ? err.message : 'Submit failed')+'</span>';
  }
  _fbDraft = null; _fbHistory = []; _fbLastQuestion = '';
}

feedback.submitFeedback = submitFeedback;
feedback.fbAnswerClarify = fbAnswerClarify;
feedback.fbSkipClarify = fbSkipClarify;

// ── CONSENT_TEXT — moved VERBATIM from index.html (v128.37, refactor R10) ──
// Sole-reader data constant (never written cross-bundle, so the "state
// stays declared in the HTML" law does not apply). Window-bound so any
// classic-script or cross-bundle bare reference keeps resolving.
var CONSENT_TEXT = {
  en: {
    dir: 'ltr',
    title: 'Your information in Shift',
    short: 'ALGT collects your name, employee code, shifts, clock-in times and device location to manage your work. Chat messages and store emails are kept for 31 days; most other operational records auto-delete within a year. You can ask to access, correct or delete your data at any time — contact <strong>james@algt-me.com</strong>.',
    expandLink: 'Read full privacy notice',
    collapseLink: 'Hide full notice',
    checkLabel: 'I have read and acknowledge this notice',
    btn: 'I acknowledge',
    cancel: 'Cancel',
    full: [
      ['Who collects your data', 'ALGT. General Manager: James McHugh — james@algt-me.com.'],
      ['What we collect', ['Your name and employee code', 'The store you are assigned to', 'Your scheduled shifts and worked hours', 'Clock-in and clock-out times', 'The location of the device you clock in on (used to verify you are at your store)', 'Holiday, sick and leave records', 'Daily store checklists and operational logs you complete', 'Your profile photo, if you choose to add one — visible to colleagues and Head Office wherever your name appears, and deleted when you leave']],
      ['Why we collect it', ['To plan and publish your work schedule', 'To record attendance and pay you correctly', 'To run day-to-day store operations', 'To meet legal record-keeping obligations']],
      ['Lawful basis', 'Your employment contract, together with our legitimate interest in operating the business safely and efficiently.'],
      ['How long we keep it', 'Chat messages and store emails, including their photos and attachments, are kept for 31 days. Photos and files attached to tasks and news posts are kept for 6 months. Records of what was done (tasks, announcements and confirmations) are kept for the life of the system. Operational records (clock logs, daily checklists, store logs) are kept for between 90 and 365 days depending on the type. Your employment, shift and pay records are kept while you are employed and for any further period required by law.'],
      ['Where the data is stored', ['Stored on Supabase (cloud database service)', 'Routed through Cloudflare (servers)', 'Rota suggestions are generated using Anthropic\u2019s Claude AI']],
      ['Your rights under UAE PDPL (Federal Decree-Law 45 of 2021)', ['Access: ask for a copy of your data', 'Correction: ask us to fix anything inaccurate', 'Deletion: ask us to delete your data, subject to legal record-keeping requirements', 'Withdraw consent: where consent is the lawful basis', 'Complain: to us in the first instance, or to the UAE Data Office']],
      ['', 'To exercise any of these rights, contact James McHugh at james@algt-me.com.'],
    ],
  },
  ar: {
    dir: 'rtl',
    title: 'معلوماتك في تطبيق Shift',
    short: 'تجمع شركة ALGT اسمك ورقمك الوظيفي ومناوباتك وأوقات تسجيل الدخول وموقع جهازك لإدارة عملك. تُحفظ رسائل الدردشة وبريد المتجر لمدة 31 يوماً، وتُحذف معظم السجلات التشغيلية الأخرى تلقائياً خلال عام. يمكنك طلب الوصول إلى بياناتك أو تصحيحها أو حذفها في أي وقت — تواصل مع <strong>james@algt-me.com</strong>.',
    expandLink: 'اقرأ إشعار الخصوصية الكامل',
    collapseLink: 'إخفاء الإشعار الكامل',
    checkLabel: 'لقد قرأت هذا الإشعار وأوافق عليه',
    btn: 'أوافق',
    cancel: 'إلغاء',
    full: [
      ['من يجمع بياناتك', 'شركة ALGT. المدير العام: جيمس مكهيو — james@algt-me.com.'],
      ['ما الذي نجمعه', ['اسمك ورقمك الوظيفي', 'المتجر الذي تعمل فيه', 'جدول مناوباتك وساعات عملك', 'أوقات تسجيل الدخول والخروج', 'موقع الجهاز الذي تستخدمه لتسجيل الدخول (للتحقق من تواجدك في متجرك)', 'سجلات الإجازات السنوية والمرضية والإجازات الأخرى', 'قوائم المراجعة اليومية للمتجر وسجلات التشغيل']],
      ['لماذا نجمعه', ['لإعداد ونشر جداول العمل', 'لتسجيل الحضور وصرف الرواتب بشكل صحيح', 'لإدارة العمليات اليومية للمتجر', 'للوفاء بالالتزامات القانونية لحفظ السجلات']],
      ['الأساس القانوني', 'عقد عملك، بالإضافة إلى مصلحتنا المشروعة في تشغيل العمل بأمان وكفاءة.'],
      ['مدة الاحتفاظ بالبيانات', 'تُحفظ رسائل الدردشة ورسائل بريد المتجر، بما في ذلك الصور والمرفقات، لمدة 31 يوماً. تُحفظ الصور والملفات المرفقة بالمهام والأخبار لمدة 6 أشهر. تُحفظ سجلات ما تم إنجازه (المهام والإعلانات والتأكيدات) طوال عمر النظام. تُحفظ السجلات التشغيلية (سجلات الحضور وقوائم المراجعة اليومية وسجلات المتجر) لمدة تتراوح بين 90 و365 يوماً حسب النوع. يُحتفظ بسجلات التوظيف والمناوبات والرواتب طوال فترة عملك ولأي مدة إضافية يقتضيها القانون.'],
      ['أين تُحفظ البيانات', ['Supabase (خدمة قاعدة بيانات سحابية)', 'Cloudflare (خوادم)', 'Claude من Anthropic لاقتراحات الجدولة']],
      ['حقوقك بموجب قانون حماية البيانات الإماراتي (المرسوم 45/2021)', ['الوصول: طلب نسخة من بياناتك', 'التصحيح: طلب تصحيح أي معلومات غير دقيقة', 'الحذف: طلب حذف بياناتك، مع مراعاة متطلبات حفظ السجلات', 'سحب الموافقة: حيث تكون الموافقة هي الأساس القانوني', 'الشكوى: إلينا أولاً، أو إلى مكتب البيانات الإماراتي']],
      ['', 'لممارسة أي من هذه الحقوق، يُرجى التواصل مع جيمس مكهيو على james@algt-me.com.'],
    ],
  },
};
if (typeof window !== "undefined") window.CONSENT_TEXT = CONSENT_TEXT;
